import { render, staticRenderFns } from "./ManufacturingMovements.vue?vue&type=template&id=361a0456"
import script from "./ManufacturingMovements.vue?vue&type=script&lang=js"
export * from "./ManufacturingMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports